import styled from 'styled-components';

export const TableFilterHeader = styled.div`
	display: flex;
	padding-bottom: 32px;
	width: 100%;

	@media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
		display: none;
		position: relative;
	}
`;

export const HeadContainer = styled.div`
	align-items: center;
	display: flex;
	justify-content: space-between;
	margin-bottom: 32px;

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		align-items: normal;
		flex-direction: column;
		gap: 16px;
	}
`;

export const TitlePage = styled.h1`
	align-items: baseline;
	color: ${({ theme }) => theme.colors.principal.orion};
	display: flex;
	font-size: 32px;
	font-weight: 500;
	line-height: 1.1;

	svg {
		height: 40px;
		margin-right: 16px;
		width: 40px;
	}
`;

export const NewWithdrawalContainer = styled.div`
	align-items: center;
	display: flex;
	gap: 12px;

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		flex-direction: column;
		gap: 8px;
		width: 100%;
	}
`;

export const AmountAllowed = styled.div`
	align-items: center;
	background-color: ${({ theme }) => theme.colors.principal.vanth};
	border-radius: 20px;
	color: ${({ theme }) => theme.colors.principal.pure};
	display: flex;
	flex-direction: row;
	font-size: 14px;
	font-weight: 400;
	gap: 5px;
	padding: 12px;

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		justify-content: center;
		width: 100%;
	}
`;
export const AmountSubTitle = styled.p`
	color: ${({ theme }) => theme.colors.principal.eris};
	font-size: 11px;
	font-weight: 400;
	line-height: 12px;
`;
export const IconSettingContainer = styled.div`
	cursor: pointer;
	display: flex;
	height: 8px;
	margin-top: -15px;
`;

export const NewWithdrawalButton = styled.button`
	background-color: ${({ theme }) => theme.colors.extra.omega};
	border: 0;
	border-radius: 8px;
	color: black;
	cursor: pointer;
	height: 37px;
	min-width: 100px;
	outline: 0;
	padding: 0 12px;
	transition: background-color 0.2s ease-in-out;

	@media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
		width: 100%;
	}

	&:hover {
		background-color: ${({ theme }) => theme.colors.extra.omega}CC;
	}
`;
